import React, { Fragment, SetStateAction, Dispatch } from 'react';
import { AddPtDFormSettingItem, MedicalHistorySectionSettingsItem } from '../../api/pushGenie';
import ElementsConfigureTable from '../prescriptionPad/rightPanel/workspace/padV2/ElementsConfigureTable';

type SetMedicalHistorySectionConfig = (config: AddPtDFormSettingItem[]) => void;

const SelectionSection: React.FC<{
    medicalHistorySectionConfig: MedicalHistorySectionSettingsItem[];
    setMedicalHistorySectionConfig: Dispatch<SetStateAction<MedicalHistorySectionSettingsItem[]>>;
}> = ({ medicalHistorySectionConfig, setMedicalHistorySectionConfig }) => {
    return (
        <Fragment>
            <div className="p-16 mb-80 flex flex-col flex-1 space-y-16 h-full overflow-auto">
                <div className="p-16 overflow-y-scroll rounded-8 bg-white space-y-8">
                    <p className="body-1 bold text-darwin-neutral-1000">
                        Select sections for medical history
                    </p>

                    <ElementsConfigureTable
                        config={medicalHistorySectionConfig.map((t) => ({
                            ...t,
                            id: t.key,
                            name: t.label,
                        }))}
                        onUpdate={setMedicalHistorySectionConfig as SetMedicalHistorySectionConfig}
                    />
                </div>
            </div>
        </Fragment>
    );
};

export default SelectionSection;
